/*
 * Accessibility preferences: apply saved classes to the root element
 * before paint to avoid FOUC.
 *
 * Loaded synchronously in the head of layout/theme.liquid. Paired with
 * snippets/accessibility-preferences.liquid which renders the widget
 * itself and writes to the same localStorage key.
 *
 * This file is intentionally an external asset rather than an inline
 * script so that the FlashSpeed page-optimizer cannot mangle its
 * contents. See PR notes for background.
 */
(function () {
  try {
    var prefs = JSON.parse(localStorage.getItem('dalstrong:a11y-prefs') || '{}');
    var root = document.documentElement;
    var map = {
      easierReading: 'a11y-easier-reading',
      highContrast: 'a11y-high-contrast',
      reduceMotion: 'a11y-reduce-motion',
      strongFocus: 'a11y-strong-focus'
    };
    var anyOn = false;
    for (var k in map) {
      if (prefs[k]) { root.classList.add(map[k]); anyOn = true; }
    }
    if (anyOn) root.classList.add('a11y-enabled');
  } catch (e) {}
})();
